import React from "react";

const StringFormat = () => {
	const equalsIgnoringCase = (text, other) => {
		return text.localeCompare(other, undefined, { sensitivity: "base" }) === 0;
	};

	const getInitials = (text) => {
		let initials = "";
		if (text) {
			const matches = text.match(/\b(\w)/g);
			initials = matches.join("").toUpperCase();
		}

		return initials;
	};

	const formatTextWithKeystroke = (text, keystroke = "") => {
		const keyStrokes = Array.from(keystroke).map((stroke) => ({
			keyStroke: stroke,
			found: false
		}));
		let letterFound = false;
		const charArr = [...text];
		const value = charArr.map((l, i) => {
			let letter = l;
			const futureUpperCaseExists =
				letter !== letter.toUpperCase() &&
				charArr.slice(i + 1).some((c) => c === letter.toUpperCase());
			const matchedLetterIndex = keyStrokes.findIndex(
				(s) =>
					!s.found &&
					!futureUpperCaseExists &&
					equalsIgnoringCase(letter, s.keyStroke)
			);
			if (matchedLetterIndex >= 0) {
				letterFound = true;
				keyStrokes[matchedLetterIndex] = {
					...keyStrokes[matchedLetterIndex],
					found: true
				};
				letter = (
					<span style={{ textDecoration: "underline" }} key={letter}>
						{letter}
					</span>
				);
			}
			return letter;
		});

		if (!letterFound && keystroke) {
			return (
				<>
					{text}
					{" ("}
					<span style={{ textDecoration: "underline" }} key={keystroke}>
						{`${keystroke}`.toUpperCase()}
					</span>
					)
				</>
			);
		}

		return value;
	};

	return {
		equalsIgnoringCase,
		getInitials,
		formatTextWithKeystroke
	};
};

export default StringFormat();
